import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output
} from "@angular/core";
import { Quote } from "../../models/quote";
import { GlobalStaticService } from "../../static-services/global.static-service";

@Component({
    selector: "app-quote-work-location-component",
    templateUrl: "./quote-work-location.component.html",
    styleUrls: ["./quote-work-location.component.scss"]
})
export class QuoteWorkLocationComponent implements OnChanges {
    GlobalStaticSrv = GlobalStaticService;
    @Input("quote") quote: Quote;
    @Output() continueEventEmitter: EventEmitter<any> = new EventEmitter();
    @Output() specialEventEmitter: EventEmitter<any> = new EventEmitter();
    constructor() {}
    ngOnChanges(): void {}
    next(): void {
        if (
            this.quote.workLocationNSW +
                this.quote.workLocationQLDb +
                this.quote.workLocationACT +
                this.quote.workLocationWAb +
                this.quote.workLocationVIC +
                this.quote.workLocationTAS +
                this.quote.workLocationSA +
                this.quote.workLocationQLDa +
                this.quote.workLocationWAa +
                this.quote.workLocationNT ===
            100
        ) {
            this.quote.errorWorkLocation = false;
            this.continueEventEmitter.emit({
                finished: true,
                referral: this.quote.workLocationReferral
            });
        } else {
            this.quote.errorWorkLocation = true;
            this.continueEventEmitter.emit({
                finished: false,
                referral: this.quote.workLocationReferral
            });
        }
    }
}
